import { ActionsPathsEnum } from 'modules/newRequestPage/routes';
import { PageWithHeader } from 'modules/ui';
import {
  NavigationAndActionTime,
  NavigationAndActionDocuments,
} from 'modules/ui/icons';
import { PageText } from 'modules/ui/pageWithHeader';
import { SelectionBox, SelectionBoxContainer } from 'modules/ui/selectionBox';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export const NewRequestPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <PageWithHeader title={t('newRequestPage.title')}>
      <PageText>{t('newRequestPage.selectRequest')}</PageText>
      <SelectionBoxContainer>
        <SelectionBox
          icon={<NavigationAndActionTime />}
          title={t('newRequestPage.contractExpiration')}
          selectedText={t('newRequestPage.select')}
          onChange={() => {}}
        />
        <SelectionBox
          icon={<NavigationAndActionDocuments />}
          title={t('newRequestPage.earlyTermination')}
          selectedText={t('newRequestPage.select')}
          onChange={() => {
            history.push(ActionsPathsEnum.newEarlyTerminationRequest);
          }}
        />
      </SelectionBoxContainer>
    </PageWithHeader>
  );
};
